import React from "react";
import { Icon } from "../core/Icon.jsx";

/* Toast / snackbar. tone: positive | negative | warning | info | neutral.
   Render one inline, or stack several in a fixed container yourself. */
const TONES = {
  positive: { icon: "checkCircle", color: "var(--green-success)" },
  negative: { icon: "alertTriangle", color: "var(--red)" },
  warning:  { icon: "alertTriangle", color: "var(--orange)" },
  info:     { icon: "info", color: "var(--blue-info)" },
  neutral:  { icon: "info", color: "var(--text-muted)" },
};

export function Toast({ title, message, tone = "neutral", onClose, action, style, ...rest }) {
  const t = TONES[tone] || TONES.neutral;
  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        minWidth: 320,
        maxWidth: 440,
        padding: "14px 14px 14px 16px",
        background: "var(--slate)",
        color: "var(--white)",
        borderRadius: "var(--radius-md)",
        boxShadow: "var(--shadow-4)",
        ...style,
      }}
      {...rest}
    >
      <span style={{ marginTop: 1, color: t.color, flex: "none" }}><Icon name={t.icon} size={20} /></span>
      <div style={{ flex: 1, minWidth: 0 }}>
        {title ? <div style={{ fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: 14 }}>{title}</div> : null}
        {message ? <div style={{ fontFamily: "var(--font-sans)", fontWeight: 500, fontSize: 13, color: "rgba(255,255,255,0.8)", marginTop: title ? 2 : 0 }}>{message}</div> : null}
      </div>
      {action ? (
        <button type="button" onClick={action.onClick} style={{ border: "none", background: "transparent", color: "var(--green-bright)", fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: 13, cursor: "pointer", flex: "none" }}>
          {action.label}
        </button>
      ) : null}
      {onClose ? (
        <button type="button" aria-label="Dismiss" onClick={onClose} style={{ border: "none", background: "transparent", color: "rgba(255,255,255,0.6)", cursor: "pointer", flex: "none", display: "inline-flex", padding: 2 }}>
          <Icon name="x" size={16} />
        </button>
      ) : null}
    </div>
  );
}

export default Toast;
